"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgTelescopeFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M14.083 4.322a1.012 1.012 0 01.708-1.239l3.875-1.048a1 1 0 011.226.715l2.074 7.814a1.012 1.012 0 01-.709 1.238l-3.875 1.049a1 1 0 01-1.226-.715l-2.073-7.814zM2.034 9.676a1.012 1.012 0 01.708-1.239l2.829-.765-.008-.03a1.012 1.012 0 01.713-1.223l6.777-1.828 1.812 6.841c.072.272.228.959.228.959s-.672.208-.937.28l-.958.258a3 3 0 10-5.955.583c-.09 0-.182.012-.275.037l-2.666.74a1 1 0 01-1.233-.713l-1.035-3.9zM8.08 15.124l-2.052 5.53-.002.005c-.02.057-.316.963.623 1.275.91.302 1.239-.524 1.256-.57l.002-.005 1.985-5.375a2.99 2.99 0 01-1.812-.86zM10.248 16l2.312 5.407c.03.069.066.134.116.189.169.18.62.566 1.232.314.597-.246.61-.824.59-1.058a.63.63 0 00-.056-.195l-2.335-5.341a2.987 2.987 0 01-1.86.684z' }),
    react_1.default.createElement("path", { d: 'M12.2 13a2 2 0 11-4 0 2 2 0 014 0z' }))); };
exports.default = SvgTelescopeFilled;
//# sourceMappingURL=TelescopeFilled.js.map